import { USER_ROLES } from '../../constants/roles';
import { TERMINOLOGY } from '../../constants/terminology';
import { getRoleGuideLensKey } from './rolePermissionsGuideData';

const DEFAULT_ROLE_HELP = {
  [USER_ROLES.CARE_PARTNER]: 'Can help manage care, profile details, medication setup, and invitations.',
  [USER_ROLES.CAREGIVER]: 'Can add daily care updates without managing family settings.',
  [USER_ROLES.THERAPIST]: 'Can review shared context and add professional observations.',
};

const HOSPICE_ROLE_HELP = {
  [USER_ROLES.CARE_PARTNER]: 'Family coordinator, health proxy, or trusted decision support.',
  [USER_ROLES.CAREGIVER]: 'Hands-on helper for comfort updates, respite, companionship, or daily notes.',
  [USER_ROLES.THERAPIST]: 'Hospice professional or advisor who may need context, not app management.',
};

const CARE_TEAM_LENS_COPY = {
  default: {
    pageTitle: TERMINOLOGY.careCircle,
    ownerSubtitle: `Manage who can help care for each ${TERMINOLOGY.subjectLower}.`,
    participantSubtitle: `See who supports each ${TERMINOLOGY.subjectLower} and collaborate with the ${TERMINOLOGY.careCircleLower}.`,
    memberSectionTitle: 'Team Members',
    participantMemberSectionTitle: 'People On This Team',
    inviteButtonLabel: (childName) => `Invite for ${childName}`,
    emptyTeamText: (childName) => `No team members yet. Invite a caregiver, family member, therapist, or teacher to help support ${childName}.`,
    pendingInvitesTitle: 'Pending Invites',
    noPendingInvitesText: 'No pending invites.',
    editInviteRoleHelper: 'Choose what this person can do in the care circle.',
    participantInfo: `${TERMINOLOGY.careCircle} membership and invite history are visible here. If you need to add or remove someone, contact the Care Owner for this ${TERMINOLOGY.subjectLower}.`,
    participantRoleHint: (roleHint) => roleHint,
    acceptedInvitesText: (count) => `${count} accepted ${count === 1 ? 'invite is' : 'invites are'} already part of this team.`,
    roleHelp: DEFAULT_ROLE_HELP,
  },
  hospice: {
    pageTitle: TERMINOLOGY.careCircle,
    ownerSubtitle: 'Invite only the people who need Lifelog access for hospice coordination or daily comfort updates.',
    participantSubtitle: 'See who has Lifelog access for hospice coordination, comfort updates, and shared context.',
    memberSectionTitle: 'People With Lifelog Access',
    participantMemberSectionTitle: 'People With Lifelog Access',
    inviteButtonLabel: (childName) => `Invite for ${childName}`,
    emptyTeamText: 'No team members yet. Invite family coordinators, hands-on helpers, or specialists only when they need access. Hospice center staff may belong in Who to Call instead.',
    pendingInvitesTitle: 'Pending Access Invites',
    noPendingInvitesText: 'No pending access invites.',
    editInviteRoleHelper: 'Choose what this person should do in Lifelog. The role names stay the same.',
    participantInfo: 'This shows who has Lifelog access. Hospice center contacts who only need to be listed may belong in Who to Call instead.',
    participantRoleHint: (roleHint) => `${roleHint} Hospice titles can map differently here; app access is based on what this person needs to do in Lifelog.`,
    acceptedInvitesText: (count) => `${count} accepted ${count === 1 ? 'invite is' : 'invites are'} already part of this hospice access list.`,
    roleHelp: HOSPICE_ROLE_HELP,
  },
};

export const getCareTeamLensCopy = (child = {}) => (
  CARE_TEAM_LENS_COPY[getRoleGuideLensKey(child)] || CARE_TEAM_LENS_COPY.default
);

